export default "__VITE_ASSET__BGtq5$oB__"